export default {
  interval: 15, // in minutes
}
